import React, { useEffect, useRef } from "react";
import { Form, Button } from 'semantic-ui-react';
import { useForm } from "react-hook-form";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useLocation, Link } from "react-router-dom";
import { HTTPURL, REQUEST_OPTIONS } from "../constants/matcher";
import {Child} from "../Utils/Child";

// import {useRef} from 'react';

const Login = () => {
    // const navigate = useNavigate();
    // const location = useLocation();

    const childRef = useRef(null);

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset
    } = useForm();

    const onSubmit = (data) => {
        childRef.current.login(data, 'user');
    }

    return (
      <section className="h-100 bg-dark">
        <Child ref={childRef} />
          <div className="container py-5 h-100">
              <div className="row d-flex justify-content-center align-items-center h-100">
                  <div className="col">
                      <div className="card card-registration my-4">
                          <div className="row g-0">
                              <div className="col-xl-6 d-none d-xl-block">
                                  <img src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-registration/img4.webp"
                                      alt="" className="img-fluid"
                                  />
                              </div>

                              <div className="col-xl-6">
                                  <Form onSubmit={handleSubmit(onSubmit)}>
                                      <div className="card-body p-md-5 text-black">
                                          <h3 className="mb-5 text-uppercase">User Login</h3>

                                          <div className="form-outline mb-4">
                                              <Form.Field>
                                                  <label className="form-label" htmlFor="Email Address">Email Address</label>
                                                  <input
                                                      placeholder='Email Address'
                                                      type="email"
                                                      {...register("email",
                                                          {
                                                              required: true,
                                                              pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                                                          })}
                                                      className="form-control form-control-lg"
                                                  />
                                              </Form.Field>
                                              {errors.email && errors.email.type === "required" && <span className="validation-error">This is required</span>}
                                              {errors.email && errors.email.type === "pattern" && <span className="validation-error">Must be a valid email</span>}
                                          </div>

                                          <div className="form-outline mb-4">
                                              <Form.Field>
                                                  <label className="form-label" htmlFor="Password">Password</label>
                                                  <input
                                                      placeholder='Password'
                                                      type="password"
                                                      {...register("password", {
                                                          required: true,
                                                          pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,15}$/
                                                      })}
                                                      className="form-control form-control-lg"
                                                  />
                                              </Form.Field>
                                              {errors.password && errors.password.type === "required" && <span className="validation-error">This is required</span>}
                                              {errors.password && errors.password.type === "pattern" && <span className="validation-error">At least 6 chars long,digit,upper case,lower case</span>}
                                          </div>
                                          
                                          <div className="d-flex align-items-center justify-content-between pt-3">
                                            <div className="forgot-password d-flex align-items-center">
                                                <Link className="text-secondary" to="/forgot-password">Forgot password?</Link>
                                            </div>
                                            <div className="d-flex justify-content-end">
                                                <Button type="button" className="btn btn-light btn-lg sap-btn-light" onClick={() => reset()}>Reset</Button>
                                                <Button type='submit' className="btn btn-warning btn-lg ms-2 sap-btn-dark">Submit</Button>
                                            </div>
                                          </div>


                                      </div>
                                  </Form>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </section>
  )
}

const Logout = () => {
    const childRef = useRef(null);
    useEffect(() => {
        childRef.current.logout('user');
    }, []);

    return (
        <Child ref={childRef} />
    )
}

const LogoutBKP = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const loggedInUser = localStorage.getItem("user-token");
        if (loggedInUser) {
            localStorage.clear();
            toast.success("User logged out")
            navigate("/");
        }
    }, []);
}

export {Login, Logout};